<template>
  <div class="result">
    <div class="result_nav">
      <navbar
        :titletext="pageTitle"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <van-row class="content">
        <van-col span="24" class="icon">
          <img
            v-if="type != 3"
            src="../../../assets/purchaseSupplier/order/success.png"
          />
          <img
            v-if="type == 3"
            src="../../../assets/purchaseSupplier/order/audit.png"
          />
        </van-col>
        <van-col span="24" class="tips">{{ tips }}</van-col>
      </van-row>
      <van-row>
        <van-col span="24" v-if="type != 6">
          <btn
            :btntext="'返回'"
            :btnwidth="'34.3rem'"
            :height="'4.4rem'"
            :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
            :borderradius="'2.2rem'"
            :btncolor="'#fff'"
            :fontsize="'1.6rem'"
            :fontweight="700"
            @btnClick="goBack"
          />
        </van-col>
        <van-col span="24" v-if="type == 6">
          <btn
            :btntext="'直接查看'"
            :btnwidth="'16.4rem'"
            :height="'4.3rem'"
            :bgcolor="'#fff'"
            :btnborder="'solid 0.05rem #ccc'"
            :btnmargin="'0 1.3rem 0 0'"
            :borderradius="'2.2rem'"
            :btncolor="'#333'"
            :fontsize="'1.6rem'"
            @btnClick="seePdf"
          />
          <btn
            :btntext="'复制下载链接'"
            :btnwidth="'16.5rem'"
            :height="'4.4rem'"
            :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
            :borderradius="'2.2rem'"
            :btncolor="'#fff'"
            :fontsize="'1.6rem'"
            @btnClick="copyLink"
          />
          <span ref="copylink" class="copylink">{{ this.pdfSrc }}</span>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      pageTitle: "",
      tips: "",
      type: "", //1确认收货  2修改成功  3发票提交成功  4绑定成功  5修改成功  6生成待发货订单记录
      pdfSrc: "",
    };
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  created() {
    this.pdfSrc = this.$route.query.pdfSrc;
    this.type = this.$route.query.type;
    if (this.type == 1) {
      this.pageTitle = "确认收货";
      this.tips = "已确认收货";
    }
    if (this.type == 2) {
      this.pageTitle = "修改成功";
      this.tips = "库存修改成功";
    }
    if (this.type == 3) {
      this.pageTitle = "提交成功";
      this.tips = "发票提交成功，等待审核中";
    }
    if (this.type == 4) {
      this.pageTitle = "绑定成功";
      this.tips = "绑定成功";
    }
    if (this.type == 5) {
      this.pageTitle = "修改成功";
      this.tips = "修改成功";
    }
    if (this.type == 6) {
      this.pageTitle = "生成记录";
      this.tips = "待发货订单记录已生成";
    }
  },
  methods: {
    goBack() {
      if (this.type == 3) {
        this.$router.go(-2);
      } else {
        this.$router.go(-1);
      }
    },
    seePdf() {
      // sessionStorage.setItem("orderResult", true);
      // this.$router.push({
      //   path: "/purchaseSupplier/excel",
      //   query: {
      //     pdfSrc: this.pdfSrc,
      //   },
      // });
      let url = `${window.location.protocol}//${window.location.host}/purchaseSupplier/excel?pdfSrc=${this.pdfSrc}`;
      window.location.href = url;
    },
    copyLink() {
      const creditor_range = document.createRange();
      creditor_range.selectNode(this.$refs.copylink);
      const creditor_selection = window.getSelection();
      if (creditor_selection.rangeCount > 0)
        creditor_selection.removeAllRanges();
      creditor_selection.addRange(creditor_range);
      document.execCommand("Copy");
      this.$toast("复制成功，请打开浏览器查看");
      creditor_selection.removeAllRanges();
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.result {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .result_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
  }

  .box {
    padding: 10.3rem 1.6rem 0;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .content {
      height: 25.7rem;
      text-align: center;
      background: #fff;
      margin-bottom: 1.6rem;
      padding: 6.7rem 1.6rem;
      border-radius: 0.8rem;
      box-sizing: border-box;

      .icon {
        text-align: center;

        img {
          width: 8.1rem;
          margin-bottom: 1.2rem;
        }
      }

      .tips {
        color: #333;
        font-size: 2rem;
        line-height: 2.8rem;
        font-weight: 700;
      }
    }

    .copylink {
      width: 0;
      height: 0;
      font-size: 0;
      display: inline;
    }
  }
}
</style>